const DEFAULTS = Object.freeze({
  config: {
    initialExpandedItems: "FIRST",
    expandOnlyOne: false
  }
});
export {
  DEFAULTS
};
//# sourceMappingURL=defaults.js.map
